<template>
  <div :class="`customized-search ${className}`">
    <div class="search-box" @click="$jump('/productlsit')">
      <img
        class="icon"
        src="@/assets/images/customizedComponents/search_icon.png"
        alt=""
      />
      <span class="text">搜索您感兴趣的内容</span>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {
    setData: {
      type: Object,
      default: () => {
        return {
          topSpace: 'small', // 上边距 small medium big
          bottomSpace: 'small', // 下边距 small medium big
        }
      },
    },
  },
  data() {
    return {
      className: `topSpace-${this.setData.topSpace} bottomSpace-${this.setData.bottomSpace}`,
    }
  },
  created() {},
  methods: {},
}
</script>

<style lang="less" scoped>
.customized-search {
  background-color: #fff;
  .search-box {
    margin: 0 auto;
    width: 355px;
    height: 34px;
    background: #f5f5f5;
    border-radius: 10px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: flex-start;
    align-items: center;
    .icon {
      width: 16px;
      height: 16px;
      margin: 0 8px 0 10px;
    }
    .text {
      flex: 1;
      font-size: 13px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
  }
}
.topSpace-medium {
  padding-top: 10px;
}
.topSpace-big {
  padding-top: 15px;
}

.bottomSpace-medium {
  padding-bottom: 10px;
}
.bottomSpace-big {
  padding-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/view/customize/customizedComponents/Search.vue